import { render, staticRenderFns } from "./news1.vue?vue&type=template&id=24620954&"
var script = {}
import style0 from "./news1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "news1.vue"
export default component.exports